function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _title, _defs, _g;
var _excluded = ["decorative", "title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBird(props) {
  var _props = props,
    decorative = _props.decorative,
    title = _props.title,
    titleId = _props.titleId,
    desc = _props.desc,
    descId = _props.descId,
    filteredProps = _objectWithoutProperties(_props, _excluded);
  props = _objectSpread(_objectSpread({}, filteredProps), {}, {
    focusable: false
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bird")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bird_svg__a",
    d: "M0 0h120v120H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-660.000000, -138.000000) translate(408.000000, 138.000000) translate(252.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bird_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bird_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#bird_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bird_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0075BE",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.722 50.938c0-9.822-7.74-17.784-17.286-17.784-4.392 0-15.041.038-15.041.038s-1.955.008-1.987 1.97c0 0-.258 10.472-.258 15.776 0 9.822 7.74 17.784 17.286 17.784 9.546 0 17.286-7.962 17.286-17.784z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76 40.032c-1.574-2.98-3.937-5.562-6.97-7.344-3.855-2.263-13.245-7.734-13.245-7.734s-1.691-.984-2.6.753c0 0-4.854 9.089-7.204 13.77-3.48 6.936-2.088 15.374 2.897 20.991"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0075BE",
    d: "M59 55a2 2 0 100-4 2 2 0 000 4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0075BE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 57.173C3 76.959 18.044 93 36.602 93c18.557 0 33.6-16.04 33.6-35.827V39.05l-12.423-.053s-13.996-1.18-23.778 13.83C23.722 68.6 3 57.173 3 57.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillOpacity: 0.1,
    d: "M67.985 65.053h50.345V34.068H67.985z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6345A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M73.95 38.95s-1.969 0-1.969 1.968v17.498s0 1.967 1.97 1.967h36.518s1.968 0 1.968-1.967V40.918s0-1.968-1.968-1.968H73.95zM73 40l39 20m-39 0l39-20"
  })))));
}
export default SvgBird;